module.exports = __webpack_public_path__ + "images/emoji/cow2.2c336ac0e40717c8c32f.png";